import {useContext} from "react";
import {useNavigate} from "react-router";
import {HotIssueContext} from "./hotssue/HotIssueContextProvider";
import {callApiArchiveIssue, callApiCloseIssueAsInquiry, callApiCloseIssueAsOrder, callApiRestoreIssueFromArchive} from "./useIssueApi";

/**
 * Akcje cyklu życia archiwum sprawy dla strony ShowIssuePage.
 * Zwykła archiwizacja kończy się na listingu spraw (finishArchiveFlow), natomiast zamknięcie
 * jako zapytanie/zamówienie oraz przywrócenie z archiwum przeładowują bieżącą stronę sprawy
 * (wzorzec IssueAssigneeChangerModal) — użytkownik zostaje na sprawie i widzi baner archiwum.
 */
export function useIssueArchiveActions(issueId: string) {
    const navigate = useNavigate();
    const {currentHotIssueSummary, clearHotIssue} = useContext(HotIssueContext);

    const clearHotIssueIfCurrent = () => {
        if (currentHotIssueSummary?.id === issueId) {
            clearHotIssue();
        }
    };

    const archiveWithReason = (reason: string): Promise<void> =>
        callApiArchiveIssue(issueId, reason).then(() => {
            clearHotIssueIfCurrent();
        });

    const finishArchiveFlow = () => navigate("/browse-issues");

    const restoreFromArchive = (): Promise<void> =>
        callApiRestoreIssueFromArchive(issueId).then(() => {
            window.location.reload();
        });

    const closeAsInquiry = (inquiryNumber: string): Promise<void> =>
        callApiCloseIssueAsInquiry(issueId, inquiryNumber).then(() => {
            clearHotIssueIfCurrent();
            window.location.reload();
        });

    const closeAsOrder = (wentechCaseNumber: string): Promise<void> =>
        callApiCloseIssueAsOrder(issueId, wentechCaseNumber).then(() => {
            clearHotIssueIfCurrent();
            window.location.reload();
        });

    return {archiveWithReason, finishArchiveFlow, restoreFromArchive, closeAsInquiry, closeAsOrder};
}
